<template>
	<div class="triggeractionspoilmessageentry triggerActionLight">
		<Icon name="dragZone"
			class="orderBt"
			data-noselect
			v-tooltip="$t('triggers.reorder_tt')" />

		<ToggleButton class="field" v-model="action.enabled" small />

		<Icon name="trash" />

		<span>{{ $t("triggers.actions.delete_message.info") }}</span>

		<div class="actions">
			<TTButton transparent icon="merge" @click="$emit('addCondition')" v-tooltip="$t('triggers.condition.add_tt')" />
			<TTButton class="deleteBt" alert icon="trash" @click="$emit('delete')" />
		</div>
	</div>
</template>

<script lang="ts">
import DurationForm from '@/components/DurationForm.vue';
import TTButton from '@/components/TTButton.vue';
import ParamItem from '@/components/params/ParamItem.vue';
import PlaceholderSelector from '@/components/params/PlaceholderSelector.vue';
import type { TriggerActionTypes, TriggerData } from '@/types/TriggerActionDataTypes';
import { Component, Prop, toNative } from 'vue-facing-decorator';
import AbstractTriggerActionEntry from './AbstractTriggerActionEntry';
import ToggleButton from '@/components/ToggleButton.vue';

@Component({
	components:{
		TTButton,
		ParamItem,
		ToggleButton,
		DurationForm,
		PlaceholderSelector,
	},
	emits:["delete", "addCondition"],
})
class TriggerActionDeleteMessageEntry extends AbstractTriggerActionEntry {

	@Prop
	declare action:TriggerActionTypes;

	@Prop
	declare triggerData:TriggerData;

}
export default toNative(TriggerActionDeleteMessageEntry);
</script>

<style scoped lang="less">
.triggeractionspoilmessageentry{
}
</style>
